import React, { useContext } from "react";
import "./Banner.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";

function Banner() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Banner">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7 col-sm-7  order-sm-1 order-2">
              <div className="content_holder">
                <div>
                  <div className="heading_holder">
                    <h4>
                      {language == 1 ? "Internships" : "Stages"}
                      <span className="bold_span"> & </span>{" "}
                      {language == 1 ? "Study Abroad" : "Étudier à l'étranger"}
                      <span className="bold_span">
                        {" "}
                        {language == 1
                          ? "Programs Simplified For You"
                          : "Programmes simplifiés pour vous"}{" "}
                      </span>
                    </h4>

                    {/* <p>
                      Confidently start your global journey. From{" "}
                      <span className="bold_text"> counselling </span> to{" "}
                      <span className="bold_text"> placements </span>, we guide
                      you every step of the way.
                    </p> */}

                    <p>
                      {language == 1
                        ? "Start your global journey with"
                        : "Commencez votre parcours international avec"}{" "}
                      <span className="bold_text">
                        {" "}
                        {language == 1 ? "confidence." : "confiance."}
                      </span>{" "}
                      {language == 1 ? "From" : "De"}
                      <span className="bold_text">
                        {" "}
                        {language == 1
                          ? "counselling to placements,"
                          : "du conseil au placement,"}{" "}
                      </span>
                      {language == 1
                        ? "we guide you at every step."
                        : "nous vous guidons à chaque étape."}
                    </p>
                  </div>

                  <Link to={"/contact-us"}>
                    <Button type="button" className="Get_Guidance_btn">
                      {language == 1 ? "Get Guidance" : "Obtenir des conseils"}
                    </Button>
                  </Link>

                  <div className="onboarded_student_holder">
                    <div className="students_profiles_holder">
                      <div>
                        <div className="img_holder">
                          <img
                            src="/assets/images/home/banner/img_1.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="img_holder img_back_holder">
                          <img
                            src="/assets/images/home/banner/img_2.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="img_holder img_back_holder">
                          <img
                            src="/assets/images/home/banner/img_3.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="img_holder img_back_holder">
                          <img
                            src="/assets/images/home/banner/img_4.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="img_holder img_back_holder">
                          <img
                            src="/assets/images/home/banner/img_5.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="img_holder img_back_holder">
                          <img
                            src="/assets/images/home/banner/img_1.webp"
                            alt="student"
                            className="student_img"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="text_holder">
                      <p>
                        100 +{" "}
                        {language == 1
                          ? "Students Onboarded Successfully"
                          : "Étudiants intégrés avec succès"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-sm-5 col-10 order-sm-2 order-1">
              <div className="banner_person_holder">
                <img
                  src="/assets/images/home/banner/banner-girl.png"
                  alt="logo"
                  className="person_img"
                />
                {/* <img
                  src="/assets/images/home/banner/banner-bg-girl.png"
                  alt="logo"
                  className="person_img"
                /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
